/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { UsageError } from "@fluidframework/telemetry-utils/internal";
/**
 * @internal
 */
export class DocumentStorageServiceProxy {
    set policies(policies) {
        this._policies = policies;
    }
    get policies() {
        return this._policies ?? this.internalStorageService.policies;
    }
    constructor(internalStorageService) {
        this.internalStorageService = internalStorageService;
    }
    async getSnapshotTree(version, scenarioName) {
        return this.internalStorageService.getSnapshotTree(version, scenarioName);
    }
    async getSnapshot(snapshotFetchOptions) {
        if (this.internalStorageService.getSnapshot !== undefined) {
            return this.internalStorageService.getSnapshot(snapshotFetchOptions);
        }
        throw new UsageError("getSnapshot api should exist on internal storage in documentStorageServiceProxy class");
    }
    async getVersions(versionId, count, scenarioName, fetchSource) {
        return this.internalStorageService.getVersions(versionId, count, scenarioName, fetchSource);
    }
    async uploadSummaryWithContext(summary, context) {
        return this.internalStorageService.uploadSummaryWithContext(summary, context);
    }
    async downloadSummary(handle) {
        return this.internalStorageService.downloadSummary(handle);
    }
    async createBlob(file) {
        return this.internalStorageService.createBlob(file);
    }
    async readBlob(blobId) {
        return this.internalStorageService.readBlob(blobId);
    }
}
//# sourceMappingURL=documentStorageServiceProxy.js.map